import type { Prototype } from "../prototype-types";

export const poojaJumaniPrototypes: Prototype[] = [
  {
    id: "ads-display-banner",
    name: "Ads Display Banner",
    path: "/pj/ads-display-banner",
    description:
      "Explores display banners as a native ad format embedded across retailer journey touchpoints — home feed, search results, brand pages, and category browse.",
    owner: "Pooja",
    createdAt: "2026-04-23",
    lastUpdated: "2026-04-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0e22340418dbc9f2b28e758e7f8b9d5b902dbacbadae124d15ea06afe91446ee.png",
    creationTool: "claude-code",
  },
];
